import { useEffect, useState } from 'react';
import { createFHIRClient } from '../lib/fhir';
import { useDispatch } from 'react-redux';
import { getEHRCorelationContext } from '../store/actions/ehr';
import { useSelector } from 'react-redux';
import { fhirPatient, fhirPractitioner } from '../store/slices/ehr';
import { useNavigate } from 'react-router-dom';
import { createEncounter } from '../../ambient_solo/store/actions/encounter';

/*
  FHIRAuthentication is mean to be used loaded in the callback URL for EMR web launches.
  It co-relates FHIR patient and practitioner context with our records and redirects to:
  - /appointments page if an appointment exists
  - /encounters page if not
  we pass patient_id and practitioner_id as query params to auto-filter data based on current context
*/
export const FHIRCallback = () => {
  const [patient, setPatient] = useState();
  const [practitioner, setPractitioner] = useState();
  const dispatch = useDispatch();

  const { ehrCorelationStatus, ehrCorelationContext } = useSelector(
    (state) => state?.ehrState
  );
  const navigate = useNavigate();
  useEffect(() => {
    if (ehrCorelationStatus == 'success') {
      const params = `?patient_id=${ehrCorelationContext.patient_id}&practitioner_id=${ehrCorelationContext.practitioner_id}`;
      if (ehrCorelationContext.appointment_ids?.length > 0) {
        navigate(`/appointments/${params}`);
      } else {
        const patientName =
          patient.name.find((t) => t.use === 'official')?.given?.join(' ') ||
          '';
        const current_date = new Date();
        const formattedDate = `${current_date.getMonth() + 1}/${current_date.getDate()}`;
        const data = {
          patient_id: ehrCorelationContext.patient_id,
          practitioner_id: ehrCorelationContext.practitioner_id,
          description: patientName + ' - ' + formattedDate,
          start_time: current_date,
        };
        dispatch(
          createEncounter(data, () => {
            navigate(`/encounters`);
          })
        );
      }
    }
  }, [ehrCorelationStatus, ehrCorelationContext]);

  useEffect(() => {
    if (patient && practitioner) {
      const data = {
        patient: {
          ehr_id: patient.id,
          name:
            patient.name.find((t) => t.use === 'official')?.given?.join(' ') ||
            '',
          birth_date: patient.birthDate,
          gender: patient.gender,
          email: patient.telecom.find((t) => t.system === 'email')?.value || '',
          phone: patient.telecom.find((t) => t.system === 'phone')?.value || '',
        },
        practitioner: {
          ehr_id: practitioner.id,
          name: practitioner.name?.[0]?.text ?? '',
        },
      };
      dispatch(fhirPractitioner(practitioner));
      dispatch(fhirPatient(patient));
      dispatch(getEHRCorelationContext(data));
    }
  }, [patient, practitioner]);

  useEffect(() => {
    const init = async () => {
      try {
        const client = await createFHIRClient();
        setPractitioner(await client.getPractitionerRead());
        setPatient(await client.getPatientRead());
      } catch (err) {
        console.error(err);
      }
    };

    init();
  }, []);

  if (ehrCorelationStatus != 'loading' && ehrCorelationStatus != 'success') {
    return (
      <div>
        {`Could not find practitioner "${practitioner.name.find((t) => t.use === 'usual')?.text || ''}" in our
        records.`}
      </div>
    );
  }
  return <div>Loading...</div>;
};

export default FHIRCallback;
